var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { UndoableAction, UserEdit } from "Server/CommandMacros";
import { Command, AssertV, AssertValidate } from "mobx-firelink";
import { GetMapObject } from "Store/firebase/mapObjects";
const MTName = "MapObject";
let ReparentMapObject = class ReparentMapObject extends Command {
    Validate() {
        AssertValidate({
            properties: {
                childID: { $ref: "UUID" },
                newParentID: { $ref: "UUID" },
            },
            required: ["childID", "newParentID"],
        }, this.payload, "Payload invalid");
        const { childID } = this.payload;
        //this.oldData = await GetAsync(()=>GetMapObject(id));
        this.oldData = GetMapObject(childID);
        AssertV(this.oldData, "oldData is null.");
    }
    GetDBUpdates() {
        const { childID, newParentID } = this.payload;
        const updates = {};
        // disconnect old-parent and child
        updates[`mapObjects/${this.oldData.parent}/.children/.${childID}`] = null;
        //updates[`mapObjects/${childID}/.parent`] = null;
        // connect new-parent and child
        updates[`mapObjects/${newParentID}/.children/.${childID}`] = true;
        updates[`mapObjects/${childID}/.parent`] = newParentID;
        return updates;
    }
};
ReparentMapObject = __decorate([
    UserEdit,
    UndoableAction()
], ReparentMapObject);
export { ReparentMapObject };
